import Vue from "vue";

const pattern = /(\w{2})(\w{4})(\w{4})(\w{4})(\w{4})(\w{4})(\w{4})/;

const bankAccountNumber = (value: string): string => {
  if (value == null) return "";
  const replaced = value.replace(pattern, "$1 $2 $3 $4 $5 $6 $7");
  return replaced;
};

Vue.filter("bankAccountNumber", bankAccountNumber);

export { bankAccountNumber };
